import React, { useState } from "react";
import { Grid, Typography, Box, Tab, Tabs, Button, Stack,  Link,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import IconButton from "@mui/material/IconButton";
import { useNavigate } from "react-router-dom";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import interPretor from "../../interpretor/interPretor";

import AiImage from "../../assets/images/AiImage.svg";
import summaryService from "../../services/summary";
import CustomizedSnackbars from "../../component/Snackbar/Index";
import Footer from "../../component/Footer/Footer";
import { useSearchParams } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";

const LoginPage = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openSnackbarTitle, setOpenSnackbarTitle] = useState("");
  const [showPassword, setShowPassword] = useState(true);
  const [showConformpassword, setshowConformpassword] = useState(true);

  const handleClickShowPassword = () => setShowPassword((show) => !show);

  const handleClickshowConformpassword = () => {
    setshowConformpassword(!showConformpassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleFormSubmit = async (value) => {
    let data = {
      newPassword: value.password,
      confirmPassword: value.conformpassword,
    };
    interPretor.setHeader(
      "x-access-token", token,
     
      // "Authorization",
      // `Bearer ${response?.data?.token}`
    );
    try {
      const response = await summaryService.postCreatePassword(data);
      if (response.ok) {
       
        setOpenSnackbar(true);
        setOpenSnackbarTitle("Password updated succefully");
        navigate('/')
      } else {
        if (Object.keys(response?.data).length > 0) {
          setOpenSnackbar(true);
          setOpenSnackbarTitle(response?.data?.error);
        } else {
          setOpenSnackbar(true);
          setOpenSnackbarTitle("Some thing went wrong");
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Formik
        enableReinitialize
        initialValues={{
          password: "",
          conformpassword: "",
        }}
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .trim()        
            .nullable()
            .matches(
              /^.*(?=.{8,})((?=.*[!@#$%^&*()\-_=+{};:,<.>]){1})(?=.*\d)((?=.*[a-z]){1})((?=.*[A-Z]){1}).*$/,
              "Password must contain at least 8 characters, one uppercase, one number and one special case character"
            )
            .required("Password is Required."),
          conformpassword: Yup.string()
            .trim()      
            .nullable()
            .oneOf([Yup.ref('password'), null], 'Passwords must match')
            .required("Confirm password is Required."),
        })}
        onSubmit={(values) => {
          handleFormSubmit(values);
        }}
      >
        {({
          errors,
          handleBlur,
          handleChange,
          values,
          touched,
          setFieldValue,
          getFieldProps,
        }) => (
          <Form>
            <Grid container sx={{mt:"5rem",mb:"3rem"}}>
              {/* <Grid
                xs={12}
                sx={{ background: "#caf0f8", padding: "3rem", height: "200px" }}
              /> */}
              <Grid xs={12} textAlign="center">
                <Box
                  sx={{
                    display: "flex",
                    padding: "1rem",
                    justifyContent: "center",
                  }}
                >
                  <img
                    src={AiImage}
                    alt="AiImage"
                    width="250px"
                    height="auto"
                  />
                </Box>
              </Grid>
              <Grid xs={12} className={classes.loginBlock}>
                <Box className={classes.contentBlock}>
                  <Box mt={2.5}>
                    <TextField
                      className={classes.textFieldWidth}
                     
                      // autoComplete="current-password"
                      type={showPassword ? "password" : "text"}
                      label="New Password*"
                      {...getFieldProps("password")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={handleClickShowPassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showPassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      error={Boolean(touched.password && errors.password)}
                      helperText={touched.password && errors.password}
                    />
                  </Box>

                  <Box mt={2.5}>
                    <TextField
                      className={classes.textFieldWidth}
                      size="small"
                      // autoComplete="current-password"
                      type={showConformpassword ? "password" : "text"}
                      label="Confirm Password*"
                      {...getFieldProps("conformpassword")}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton
                              edge="end"
                              onClick={handleClickshowConformpassword}
                              onMouseDown={handleMouseDownPassword}
                            >
                              {showConformpassword ? (
                                <VisibilityOff />
                              ) : (
                                <Visibility />
                              )}
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      error={Boolean(
                        touched.conformpassword && errors.conformpassword
                      )}
                      helperText={
                        touched.conformpassword && errors.conformpassword
                      }
                    />
                  </Box>
                  <Typography mt={2} textAlign="right">
                    Remember your password?
                    <Link
                      onClick={() => navigate("/login")}
                      className={classes.login}
                    >
                      {" "}
                      Login
                    </Link>
                  </Typography>
                  <Box mt={1.5}>
                    <Button
                      className={classes.textFieldWidth}
                      variant="contained"
                      type="submit"
                    >
                      submit
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Form>
        )}
      </Formik>
      <Footer />

      <CustomizedSnackbars
        open={openSnackbar}
        close={() => setOpenSnackbar(false)}
        title={openSnackbarTitle}
      />
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  logoAlign: {
    display: "block !important",
    marginTop: "4rem",
    [theme.breakpoints.down("md")]: {
      marginTop: "3rem",
    },
  },
  boxAlign: {
    display: "flex",
    padding: "4rem 3rem",
    [theme.breakpoints.down("md")]: {
      padding: "4rem 2rem",
    },
    [theme.breakpoints.down("sm")]: {
      padding: "4rem 1rem",
    },
  },
  textFieldWidth: {
    width: "370px",
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  loginBlock: {
    display: "flex",
    justifyContent: "center",
    margin: "auto",
    marginTop: "1rem",
  },
  contentBlock: {
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "10px",
    opacity: 1,
    padding: "1rem 2rem",
    marginBottom: "3rem",
    [theme.breakpoints.down("sm")]: {
      margin: "0rem 1rem",
    },
  },
  signIn: {
    fontWeight: "bold",
    textAlign: "center",
    color: "orange",
    marginTop: "1rem",
    lineHeight: 1.5,
    letterSpacing: "1px",
    cursor: "pointer",
  },
}));

export default LoginPage;
